export default __webpack_public_path__ + "static/media/history.46820301.png";